import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';

const ToggleButton = ({ enabled, handleClick }) => {
  const icon = enabled ? 'pi pi-check' : 'pi pi-times';

  const className = enabled ? 'p-button-success' : 'p-button-danger';

  return (
    <Button
      icon={icon}
      className={className}
      onClick={handleClick}
    />
  );
};

ToggleButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default ToggleButton;
